import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../_services/index';
import 'rxjs/add/operator/map';
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import { environment } from '.../../environments/environment';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { process, State, aggregateBy } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { SelectableSettings, DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';

declare var $: any;

const distinctZone = data => data.filter((x, idx, xs) => xs.findIndex(y => y.zone === x.zone) === idx);
const distinctWard = data => data.filter((x, idx, xs) => xs.findIndex(y => y.ward === x.ward) === idx);
const distinctPaymentMode = data => data.filter((x, idx, xs) => xs.findIndex(y => y.paymentMode === x.paymentMode) === idx);
const distinctIsValid = data => data.filter((x, idx, xs) => xs.findIndex(y => y.isValid === x.isValid) === idx);

@Component({
	selector: 'app-kcc-dashboard',
	templateUrl: './kcc-dashboard.component.html',
	styleUrls: [ './kcc-dashboard.component.scss' ]
})
export class KccDashboardComponent implements OnInit {
	search: any;
	showLoader: any;
	totalKccData: any;
	totalKccAmount: number;
	totalKccList: Array<{}>;
	zoneList: any;
	prjId: any;
	zoneId: any;
	startDate: any;
	endDate: any;
	wardId: any;
	defaultStartDate: any;
	defaultEndDate: any;
	dataRangeModal: any;
	wardList: any;
	userId: any;
	syncing: boolean;
	loaderClass: string;
	kccRecardStatus: boolean;
	totalKccAmountINR: any;

	public distinctZone: any[]
	public distinctWard: any[]
	public distinctPaymentMode: any[]
	public distinctIsValid: any[]

	public state: State = {
		skip: 0,
		take: 50,
		filter: {
		  logic: 'and',
		  filters: []
		}
	  };
	  public pageSize: any
	  public checkboxOnly = false;
	  public mode = 'multiple';
	  public selectableSettings: SelectableSettings;
	  public groups: GroupDescriptor[] = [];
	  public view: Observable<GridDataResult>;
	  public gridCollectorData: DataResult;

	  
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }
  private loadProducts(): void {
    this.gridCollectorData = process(this.totalKccList, { group: this.groups });
  }

	constructor(private http: HttpClient, private auth: AuthService, private loaderService: LoaderService) {
		this.loaderService.status.subscribe((val: boolean) => {
			this.showLoader = val;
		});
		this.zoneId = null;
		this.wardId = null;
		var firstDay = new Date();
		var lastDay = new Date();
		this.defaultStartDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
		this.defaultEndDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
		this.dataRangeModal = {
			beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() },
			endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() }
		};
	}

	getKccData(fromDate, toDate) {
		var apiUrl =
			environment.apiUrl +
			'payment/dashboard?prjId=' +
			this.prjId +
			'&startDate=' +
			fromDate +
			'&endDate=' +
			toDate;

		if (this.wardId && this.zoneId) {
			apiUrl += '&zoneId=' + this.zoneId + '&wardId=' + this.wardId;
		} else if (this.wardId) {
			apiUrl += '&wardId=' + this.wardId;
		} else if (this.zoneId) {
			apiUrl += '&zoneId=' + this.zoneId;
		}

		this.loaderService.display(true);
		this.http.get(apiUrl).subscribe((data) => {
			this.totalKccData = data;
			var result: any;
			result = data;
			console.log('Kcc Data', this.totalKccData);
			this.totalKccAmount = result.amount;
			this.totalKccAmountINR = this.totalKccAmount.toLocaleString('en-IN');
			this.totalKccList = result.list;
			console.log('Amount', this.totalKccAmount);
			console.log('Amount', this.totalKccAmountINR);
			if (this.totalKccList.length > 0) {
				this.loaderService.display(false);
				this.kccRecardStatus = false;
				this.gridCollectorData = process(this.totalKccList, this.state);
				this.distinctZone = distinctZone(this.totalKccList)
				this.distinctPaymentMode = distinctPaymentMode(this.totalKccList)
				this.distinctIsValid = distinctIsValid(this.totalKccList)
				this.distinctWard = distinctWard(this.totalKccList)
			} else {
				this.kccRecardStatus = true;
				this.loaderService.display(false);
			}
		});
	}

	getZone() {
		this.http.get(environment.apiUrl + 'consumer/getZoneByProject?prjid=2' + '&oemid=7').subscribe((data) => {
			this.zoneList = data;
			console.log('Zone List', this.zoneList);
		});
	}

	selectZone(data) {
		if (data) {
			this.getKccData(this.startDate, this.endDate);
		} else {
			this.zoneId = null;
			this.getKccData(this.startDate, this.endDate);
		}
	}

	public dataStateChange(state: DataStateChangeEvent): void {
		this.state = state;  
		  this.gridCollectorData = process(this.totalKccList, this.state);
		  if(state && state.group){  
		  this.gridCollectorData = process(this.totalKccList, this.state);
		} 
	  }

	getAllWard() {
		this.http
			.get(environment.apiUrl + 'consumer/getZoneByProject?prjid=' + this.prjId + '&oemid=8')
			.subscribe((data) => {
				this.wardList = data;
			});
	}

	getWard() {
		this.http
			.get(environment.apiUrl + 'uccnew/getWardByProject?prjid=' + this.prjId + '&userId=' + this.userId)
			.subscribe((data) => {
				var result: any;
				result = data;
				this.zoneList = [];
				for (var i = 0; i < result.length; i++) {
					result[i].id = result[i].entityid;
					result[i].entityname = result[i].entityName;
					this.zoneList.push({ entityname: result[i].Zone, id: result[i].ZONEID });
					this.zoneId = result[i].ZONEID;
				}
				this.wardList = data;
				if (this.wardList.length == 0) {
					this.getAllWard();
					this.getZone();
					this.getKccData(this.startDate, this.endDate);
				} else {
					this.getKccData(this.startDate, this.endDate);
				}
				console.log('ward', this.wardList);
			});
	}

	selectWard(data) {
		if (data) {
			this.getKccData(this.startDate, this.endDate);
		} else {
			this.wardId = null;
			this.getKccData(this.startDate, this.endDate);
		}
	}

	onDateRangeChanged(dataRange) {
		if (this.startDate != '' || this.startDate != null || this.startDate != undefined) {
			var startDate = dataRange.beginDate.year + '-' + dataRange.beginDate.month + '-' + dataRange.beginDate.day;
			var endDate = dataRange.endDate.year + '-' + dataRange.endDate.month + '-' + dataRange.endDate.day;
			this.startDate = moment(startDate).format('YYYY-MM-DD');
			this.endDate = moment(endDate).format('YYYY-MM-DD');
			this.getKccData(this.startDate, this.endDate);
		} else {
			this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
			this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
			this.getKccData(this.startDate, this.endDate);
		}
	}

	s2ab(s) {
		const buf = new ArrayBuffer(s.length);
		const view = new Uint8Array(buf);
		for (let i = 0; i !== s.length; ++i) {
			view[i] = s.charCodeAt(i) & 0xff;
		}
		return buf;
	}
	importToExcel(data) {
		const ws_name = 'SomeSheet';
		const wb: WorkBook = { SheetNames: [], Sheets: {} };
		const ws: any = utils.json_to_sheet(data);
		wb.SheetNames.push(ws_name);
		wb.Sheets[ws_name] = ws;
		const wbout = write(wb, {
			bookType: 'xlsx',
			bookSST: true,
			type: 'binary'
		});
		saveAs(new Blob([ this.s2ab(wbout) ], { type: 'application/octet-stream' }), 'kccReport.xlsx');
	}

	syncData() {
		this.syncing = true;
		this.loaderClass = 'fas fa-sync fa-spin';
		this.getKccData(this.startDate, this.endDate);
		this.syncing = false;
		this.loaderClass = 'fas fa-sync';
	}

	ngOnInit() {
		this.getKccData(this.startDate, this.endDate);
		this.getZone();
		this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
		this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
		this.prjId = this.auth.getAuthentication().projectId;
		this.userId = this.auth.getAuthentication().id;
		this.getWard();
	}
}



// WEBPACK FOOTER //
// ./src/app/reports/kccReport/kcc-dashboard.component.ts